import(/* webpackMode: "eager", webpackExports: ["Greeting"] */ "/app/apps/royalur/src/app/Greeting.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Welcome"] */ "/app/apps/royalur/src/app/Welcome.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterProfileLink"] */ "/app/apps/royalur/src/components/layout/FooterProfileLink.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/ad/masters-ur-boards.jpg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/ad/MTG-banner.png");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/collision.png");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/icons/discord.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/icons/facebook.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/icons/instagram.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/icons/reddit.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/icons/twitter.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/logo_text_only.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/logo.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/photos/veulatonra_board_scaled.png");
;
import(/* webpackMode: "eager", webpackExports: ["CookiePreferencesButton"] */ "/app/packages/web_components/src/cookie/CookiePreferencesButton.tsx");
